import ApiModel         from '@widesk-core/models/ApiModel';
import CompleteApiModel from '@widesk-ui/models/CompleteApiModel';

export default abstract class ServiceModel extends CompleteApiModel {
	getLabelRelations?(): ApiModel[];
}